import Image from 'next/image'
import { HelpIcon } from '@pancakeswap/uikit'
import { isChainSupported } from 'utils/wagmi'
import { memo, useState } from 'react'
import { ASSET_CDN } from 'config/constants/endpoints'

export const ChainLogo = memo(
  ({ chainId, width = 24, height = 24 }: { chainId: number; width?: number; height?: number }) => {
    const [imgError, setImgError] = useState(false)

    if (isChainSupported(chainId) && !imgError) {
      return (
        <Image
          alt={`chain-${chainId}`}
          style={{ maxHeight: `${height}px` }}
          src={`/images/chains/${chainId}.png`}
          width={width}
          height={height}
          unoptimized
          onError={() => setImgError(true)}
        />
      )
    }

    return <HelpIcon width={width} height={height} />
  },
)
